import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import '../Styles/ResetPassword.scss';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: ''
  });

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');      // <-- NEW
  const [tokenValid, setTokenValid] = useState(false);

  useEffect(() => {
    const validateToken = async () => {
      try {
        const response = await fetch('/api/validate-token', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token })
        });

        const data = await response.json();
        console.log(data, "Token after the /validate-token call");

        if (data.valid) {
          setTokenValid(true);
        } else {
          setError('Invalid or expired reset link');
        }
      } catch (error) {
        setError('Invalid or expired reset link');
      }
    };

    if (token) {
      validateToken();
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    try {
      const response = await fetch('/api/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          token,
          newPassword: formData.password,
        }),
      });

      if (!response.ok) {
        throw new Error('Request failed');
      }

      // SUCCESS 🟢
      setSuccess("Your password has been reset successfully!");

      // Delay redirect so the user can see the message
      setTimeout(() => navigate('/'), 1500);

    } catch (err) {
      setError('Failed to reset password');
    }
  };

  if (!tokenValid) {
    return (
      <div className="ResetPasswordPage">
        <div className="ResetPasswordError">{error}</div>
      </div>
    );
  }

  return (
    <div className="ResetPasswordPage">
      <h2 className="ResetPasswordHeading">Reset Your Password</h2>

      {error && (
        <div className="ResetPasswordError">{error}</div>
      )}

      {success && (
        <div className="ResetPasswordSuccess">{success}</div>
      )}

      <form className="ResetPasswordForm" onSubmit={handleSubmit}>
        <div className="ResetPasswordField">
          <label>New Password</label>
          <input
            type="password"
            value={formData.password}
            onChange={(e) =>
              setFormData({ ...formData, password: e.target.value })
            }
            required
          />
        </div>

        <div className="ResetPasswordField">
          <label>Confirm Password</label>
          <input
            type="password"
            value={formData.confirmPassword}
            onChange={(e) =>
              setFormData({ ...formData, confirmPassword: e.target.value })
            }
            required
          />
        </div>

        <button type="submit" className="ResetPasswordSubmitButton">
          Reset Password
        </button>
      </form>
    </div>
  );
};

export default ResetPassword;
